import { Avatar, AvatarGroup, Box, Dialog, IconButton, Stack, Typography } from "@mui/material"
import { DAMS_SIDE_DRAWER_WIDTH } from "../styles/common"
import { ContainedButton, OutlinedButton } from "../Button/AppButton"
import { DamsAppAsset } from "../../assets/registry"
import { DamsModalProps } from "."
import { DamsColors } from "../styles/DamsColors"
import ModalInput from "../Input/ModalInput"
import VerticalGap from "../Gap/VerticalGap"
import { ReactElement } from "react"

function ModalBase({
    open,
    leftIcon,
    type = 'picture',
    showHeader = true,
    currentIndex = 3,

    title,
    subtitle,
    rightBtnTxt,
    onRightBtnPress,
    onRightBtnLoading,
    onLeftBtnLoading,
    leftBtnTxt,
    onLeftBtnPress,
    hasValidation,
    onClose,
    width=400,
    children,isFullScreen
    
}: Readonly<DamsModalProps>) {
    return (
        <Dialog
            open={open}
            // sx={styles.dialogContainer}
            onClose={onClose}
            PaperProps={{ sx: {ml:isFullScreen? 0 :`${DAMS_SIDE_DRAWER_WIDTH}px`,borderRadius: '8px',} }}
        >

            <Box
                width={width}
                p={2.3}
                // borderRadius={3}
                sx={{ backgroundColor: 'white' }}>

                {(showHeader && (type === 'action' || type === 'add-item')) && (
                    <>
                        {/* header section  */}
                        <Stack
                            height={50}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            direction={'row'}
                        >
                            <Avatar sx={styles.modalIcon} src={leftIcon ?? DamsAppAsset.icons.success} />

                            {/* close icon  */}
                            <IconButton
                                onClick={() => {
                                    if (onClose !== undefined) {
                                        onClose()
                                    }
                                }}>
                                <Avatar sx={styles.closeIcon} src={DamsAppAsset.icons.close} />
                            </IconButton>
                        </Stack>
                    </>
                )}

                {(showHeader && type === 'auth') && (
                    <>
                        {/* header section  */}
                        <Stack
                            // height={55}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            direction={'row'}
                        >
                            <Box width={48} height={48}>

                            </Box>

                            <Box mt={1}>
                                <Avatar sx={styles.modalIcon} src={leftIcon ?? DamsAppAsset.icons.success} />
                            </Box>

                            {/* close icon  */}
                            <IconButton>
                                <Avatar sx={styles.closeIcon} src={DamsAppAsset.icons.close} />
                            </IconButton>
                        </Stack>
                    </>
                )}

                {/* content  */}
                <Stack mt={type === 'info' ? 0 : 2}>
                    {type === 'action' && (
                        <>
                            <TitleSubtitleComponent
                                centered={false}
                                title={title}
                                subtitle={subtitle}
                            />

                            {/* validation input  */}
                            {hasValidation ? (
                                <>
                                    <Typography
                                        fontFamily={'Inter'}
                                        fontSize={14}
                                        fontWeight={400}
                                        color={DamsColors.Text.LabelTextLight}
                                        mt={3}
                                        mb={3}
                                    >
                                        Confirm by typing  “DF6523” to continue.
                                    </Typography>

                                    <ModalInput />
                                </>
                            ) : (
                                <VerticalGap height={20} />
                            )}
                        </>
                    )}


                    {type === 'info' && (<>

                        <Stack alignItems={'center'} mb={3}>
                            <AvatarGroup max={3}>
                                <Avatar alt="admin img 1" src={DamsAppAsset.icons.person_1} />
                                <Avatar alt="admin img 2" src={DamsAppAsset.icons.person_2} />
                                <Avatar alt="admin img 3" src={DamsAppAsset.icons.person_3} />
                            </AvatarGroup>

                        </Stack>

                        <TitleSubtitleComponent
                            centered={true}
                            title={title}
                            subtitle={subtitle}
                        />
                    </>)}


                    {type === 'picture' && (<>
                        <img
                            alt="under_construction"
                            src={DamsAppAsset.image.under_construction}
                            width={352}
                            height={220} />


                        <Box mt={3} mb={2.5}>

                            <TitleSubtitleComponent
                                centered={true}
                                title={title}
                                subtitle={subtitle}
                            />
                        </Box>

                        <Box gap={2} display={'flex'} justifyContent={'center'}>
                            {Array.from({ length: 4 }, (_, i) => 1 + i).map((num, index) => (
                                <Box
                                    width={10}
                                    height={10}
                                    borderRadius={'100%'}
                                    key={`dot-${index}`}
                                    sx={{
                                        ...(num > currentIndex ?
                                            styles.circularItem :
                                            styles.circularItemActive)
                                    }}
                                />
                            ))}
                        </Box>

                    </>)}


                    {type === 'auth' && (<>
                        <TitleSubtitleComponent
                            centered={true}
                            title={title}
                            subtitle={subtitle}
                        />

                        <Stack gap={2.5} mt={2.5}>
                            <ModalInput label="Email" />

                            <ModalInput label="Password" type="hidden-text" />
                        </Stack>


                    </>)}

                    {type === 'add-item' && (<>
                        <TitleSubtitleComponent
                            centered={false}
                            title={title}
                            subtitle={subtitle}
                        />
                        <VerticalGap height={20} />
                        {children}

                    </>)}
                </Stack>

                {/* buttons container  */}
                <Stack
                    mt={4}
                    direction={'row'}
                    gap={2}
                    justifyContent={'center'}>
                    <OutlinedButton
                        height={44}
                        width={170}
                        title={leftBtnTxt}
                        loading={onLeftBtnLoading}
                        onClick={() => {
                            if (onLeftBtnPress !== undefined) {
                                onLeftBtnPress()
                            }
                        }} />

                    <ContainedButton
                        height={44}
                        width={170}
                        
                        title={rightBtnTxt}
                        loading={onRightBtnLoading}
                        onClick={() => {
                            if (onRightBtnPress !== undefined) {
                                onRightBtnPress()
                            }
                        }}
                    />
                </Stack>
            </Box>

        </Dialog >
    )
}


function TitleSubtitleComponent({
    centered,
    title = "Modal Title",
    subtitle = "Modal Subtitle"
}: Readonly<{ centered: boolean, title: string, subtitle: string | ReactElement }>) {
    return (
        <>
            <Typography
                fontFamily={'Inter'}
                fontSize={18}
                fontWeight={600}
                textAlign={centered ? 'center' : 'left'}
                color={DamsColors.Text.Black}>
                {title}
            </Typography>
            {typeof subtitle === 'string' ?  
                    <Typography
                    fontFamily={'Inter'}
                    fontSize={14}
                    fontWeight={400}
                    textAlign={centered ? 'center' : 'left'}
                    color={DamsColors.Text.LabelTextLight}>
                    {subtitle}
                    </Typography>:
             subtitle}
  
        </>
    )

}


const styles = {

    modalIcon: {
        width: '48px',
        height: '48px',
    },

    closeIcon: {
        width: '22px',
        height: '22px',
    },

    circularItem: {
        backgroundColor: DamsColors.Background.RoundCircle
    }
    ,

    circularItemActive: {
        backgroundColor: DamsColors.Background.RoundCircleActive
    }
}

export { ModalBase }
